import max from 'lodash/max';
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  screenIndex: 0,
  complete: false,
  providerId: null,
  sessionTypeId: null,
  hasGuardian: null,
  error: null,
};
const slice = createSlice({
  name: 'patientSignup',
  initialState: initialState,
  reducers: {
    next: (state, action) => ({
      ...state,
        screenIndex: state.screenIndex + 1,
    }),
    previous: (state, action) => ({
      ...state,
      screenIndex: max([state.screenIndex - 1, 0])
    }),
    setScreenIndex: (state, action) => ({
      ...state,
      screenIndex: action.payload.screenIndex,
    }),
    complete: (state, action) => ({
      ...state,
      complete: true,
    }),
    setHasGuardian: (state, action) => ({
      ...state,
      hasGuardian: action.payload.hasGuardian,
    }),
    setProviderId: (state, action) => ({
      ...state,
      providerId: action.payload.providerId,
    }),
    setSessionTypeId: (state, action) => ({
      ...state,
      sessionTypeId: action.payload,
    }),
    setError: (state, action) => {
      return {
        ...state,
        error: action.payload,
      };
    },
    reset: (state, action) => initialState,
    setNumSteps: (state, action) => ({
      ...state,
      numSteps: action.payload,
    })
  },
});

// Extract the action creators object and the reducer
const { actions, reducer } = slice;
// Extract and export each action creator by name
export const {
  next,
  previous,
  setScreenIndex,
  complete,
  setHasGuardian,
  setProviderId,
  setSessionTypeId,
  setError,
  reset,
  setNumSteps,
} = actions;
// Export the reducer, either as a default or named export
export default reducer;
